import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Paper, TextField, Grid, Button, IconButton, Tooltip } from '@material-ui/core';
import { ReadPrerequisite } from '../../Elements'
import PrerequisiteContent from './PrerequisiteContent'
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import EditIcon from '@material-ui/icons/Edit';
import { fieldDateFormat, backendDateFormat } from '../../../constants';
import { globalGetService, globalPutService, globalPostService } from '../../../utils_v2/globalApiServices';
import { checkApiStatus } from '../../../utils_v2';
import { PageLoader } from '../../../shared_elements';
import Skeleton from '@material-ui/lab/Skeleton';
const GeneralDetail = ({currentFormDetail, params, getCurrentFormDetail}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(true);
  const [isEditAble, setEditAble] = useState(false);
  const [generalDetail, setGeneralDetail] = useState({});
  const [error, setError] = useState({});
  const [pltConstants, setPltConstants] = useState([]);
  useEffect(() => {
      getPltConstants();
  },[]);
  useEffect(() => {
    getGeneralDetails();
  }, []);
  const getPltConstants = () => {
    globalPostService(`console/get-constants/`, {constant_types:["mr_type_of_report"]})
    .then(response => {
        if(checkApiStatus(response)){
            setPltConstants(response.data.data)
        }
    })
}
  const getGeneralDetails = () => {
    globalGetService(`technical/v2/workorder/${params.workOrderSlug}/mr-claim/general-details/`)
    .then(response => {
      if(checkApiStatus(response)){
        setGeneralDetail(response.data.data);
      }
      setSkeletonLoader(false);
    })
  }
  const onUpdateGeneralDetails = () => {
    let validationInputs = {
      report_type:generalDetail?.report_type ? '':'Please select Report Type',
      report_date:generalDetail?.report_date ? moment(generalDetail.report_date).isValid() ? '':'Please enter valid Date':'Please enter Report Date',
      report_issued_place:generalDetail?.report_issued_place?.trim()?.length ? '':'Please enter Report Issued Place',
    }
    if((generalDetail?.report_date && moment(generalDetail.report_date).isValid()) && (generalDetail?.date_of_inspection && moment(generalDetail.date_of_inspection).isValid())){
      if(generalDetail?.report_date <  generalDetail?.date_of_inspection){
        validationInputs = {
          ...validationInputs,
          date_of_inspection: 'Date of Inspection should be less then or equal to Report Date'
        }
      }
    }
    if(Object.keys(validationInputs).every((k) => { return validationInputs[k] === ''})){
      setLoading(true);
      globalPutService(`technical/v2/workorder/${params.workOrderSlug}/mr-claim/general-details/`, generalDetail)
      .then(response => {
        if(checkApiStatus(response)){
          enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
          setEditAble(false);
          getCurrentFormDetail('pageLoader');
        }else{
          enqueueSnackbar(response.data.message, { variant: 'error',anchorOrigin:{horizontal:'right', vertical:'top'}});
        }
        setLoading(false);
      })
    }else{
      setError(validationInputs)
    }
  }
  const onFieldChange = (key, value) => {
    setGeneralDetail({...generalDetail, [key]:value});
  }
  const canEdit = currentFormDetail?.current_form?.permissions?.can_save; 
  return(
    <Paper className="form-detail-card">
      <p className='edit-details'>
        <ReadPrerequisite content={<PrerequisiteContent />} />
        {canEdit && !isEditAble && !skeletonLoader ?
          <span className='edit-g'>
            <IconButton size="small">
                <Tooltip title='Edit General Detail' arrow><EditIcon onClick={() => setEditAble(true)} fontSize='small' color='primary' /></Tooltip>
            </IconButton></span>:null
        }
      </p>
      <div className='scrollable-content' style={{height: `${window.innerHeight- (isEditAble ? 265:225)}px`, overflow:'auto'}}>
        { skeletonLoader ?
        <Grid container spacing={1}>
          { Array(3).fill(0).map((item, index) =>
            <Grid item xs={12} md={4} key={index}>
              <Skeleton variant="rect" animation='wave' height={56} />
            </Grid>
          )}
        </Grid>
        :
        <Grid container spacing={1}>
          <Grid item xs={12} md={4}>
            <Autocomplete
              disabled={!isEditAble}
              options = {pltConstants}
              getOptionLabel={option => option.label}
              id="report_type"
              value={generalDetail?.report_type||null}
              onChange={(e, value) => { onFieldChange('report_type', value);}}
              renderInput={params => <TextField required onFocus={(e) => setError({...error,'report_type':''})} error={error?.report_type} helperText={error?.report_type||''} {...params} label="Type of Report" margin="normal" fullWidth InputLabelProps={{shrink: true}} variant="outlined" />}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDatePicker
                disabled={!isEditAble}
                required
                margin="normal"
                id="report_date"
                label="Report Date"
                format={fieldDateFormat}
                fullWidth
                disableFuture={true}
                InputLabelProps={{shrink: true}}
                value={generalDetail?.report_date||null}
                error={error?.report_date}
                helperText={error?.report_date||''}
                onChange={(data, value) => {onFieldChange('report_date', data ? moment(data).format(backendDateFormat):data); setError({...error,'report_date':''})}}
                inputVariant="outlined"
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              disabled={!isEditAble}
              required
              id="report_issued_place"
              label="Report Issued Place"
              fullWidth
              margin="normal"
              inputProps={{maxLength: 30}}
              value={generalDetail?.report_issued_place||''}
              error={error?.report_issued_place}
              helperText={error?.report_issued_place||''}
              InputLabelProps={{shrink: true}}
              onChange={(e) => onFieldChange('report_issued_place', e.target.value)}
              onFocus={() => setError({...error,'report_issued_place':''})}
              variant="outlined"
            />
          </Grid>
        </Grid>
        }
      </div>
      { isEditAble && !skeletonLoader ?
        <div className='actions-cta'>
          <ul className='list-inline'>
            <li className='list-inline-item'>
              <Button onClick={onUpdateGeneralDetails} size='small' color='primary' variant='contained'>Save</Button>
            </li>
            <li className='list-inline-item'>
              <Button onClick={() => {setEditAble(false);getGeneralDetails(); setError({})}} size='small' color='primary' variant='outlined'>Cancel</Button>
            </li>
          </ul>
        </div>:null
      }
      { isLoading ? <PageLoader />:null}
    </Paper>
  )
}
export default withRouter(GeneralDetail);

